import { defineMessage } from 'react-intl';

export const adminSidebarMessages = {
  navLabel: defineMessage({
    id: 'admin.title',
    defaultMessage: 'Administración',
  }),
  organization: defineMessage({
    id: 'admin.sidebar.organization',
    defaultMessage: 'Organización',
  }),
  configuration: defineMessage({
    id: 'admin.sidebar.configuration',
    defaultMessage: 'Features',
  }),
  integrations: defineMessage({
    id: 'admin.sidebar.integrations',
    defaultMessage: 'Plataformas',
  }),
  stations: defineMessage({
    id: 'admin.dashboard.stationsTitle',
    defaultMessage: 'Emisoras',
  }),
  stationGroups: defineMessage({
    id: 'admin.sidebar.stationGroups',
    defaultMessage: 'Grupos de emisoras',
  }),
  users: defineMessage({
    id: 'admin.users.title',
    defaultMessage: 'Usuarios',
  }),
  groups: defineMessage({
    id: 'admin.sidebar.groups',
    defaultMessage: 'Grupos',
  }),
  alerts: defineMessage({
    id: 'admin.dashboard.alertsTitle',
    defaultMessage: 'Alertas',
  }),
  fragments: defineMessage({
    id: 'admin.dashboard.fragments',
    defaultMessage: 'Fragmentos',
  }),
  contentAi: defineMessage({
    id: 'contentAi.title',
    defaultMessage: 'Content AI',
  }),
  videoAnalysis: defineMessage({
    id: 'admin.dashboard.videoAnalysisTitle',
    defaultMessage: 'Análisis de Video',
  }),
  audit: defineMessage({
    id: 'audit.title',
    defaultMessage: 'Auditoría',
  }),
  auditTemplates: defineMessage({
    id: 'audit.reportDefinitions.templatesTitle',
    defaultMessage: 'Plantillas',
  }),
  auditMaterials: defineMessage({
    id: 'audit.auditConfig.materials',
    defaultMessage: 'Materiales',
  }),
};
